import colors from '../../../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        gridContainerCentre: {
            backgroundColor: colors[mode].secondaryBackground,
            display: 'flex',
            justifyContent: 'center',
            minHeight: '70vh',
        },
        gridContainerFooter: {
            display: 'flex',
            justifyContent: 'center',
        },
        loader: {
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%',
            'z-index': '10'
        },
        registrationRoot: {
            display: 'flex',
            height: 'fit-content',
            justifyContent: 'center',
            padding: theme.spacing(9, 4, 4, 4)
        }
    }
}

export default styles
